
import { X } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { MenuItem } from "./types/menu-item";

interface SidebarSubMenuProps {
  items: MenuItem[];
  title: string;
  onClose: () => void;
  isMobile: boolean;
}

export function SidebarSubMenu({ items, title, onClose, isMobile }: SidebarSubMenuProps) {
  return (
    <div 
      className={cn(
        "bg-white text-black border-l border-gray-200 shadow-md h-full",
        isMobile
          ? "fixed top-0 right-0 w-64 z-50 animate-in slide-in-from-right" 
          : "fixed top-[72px] left-64 w-64 z-40"
      )}
    >
      <div className="flex items-center justify-between p-4 border-b border-gray-200">
        <h2 className="font-semibold text-sm uppercase tracking-wide">{title}</h2>
        <button 
          onClick={onClose}
          className="p-1 hover:bg-gray-100 rounded-full"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <ul className="p-2 space-y-1 overflow-y-auto max-h-[calc(100vh-136px)]">
        {items.map((item) => (
          <li key={item.id}>
            <Link
              to={item.url}
              className={cn(
                "flex items-center gap-2 px-4 py-2 text-sm hover:bg-gray-100 rounded",
                !item.available && "opacity-50 pointer-events-none"
              )}
              onClick={() => {
                onClose(); // Toujours fermer le menu après un clic, peu importe si c'est mobile ou non
              }}
            >
              {item.icon && <item.icon className="w-4 h-4" />}
              <span>{item.title}</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
